import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, XIcon } from "lucide-react";
import { useState } from "react";
import { PasskeyPopupItem } from "./passkey-popup-item";

export const PasskeyPopup = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (prop: boolean) => void;
}) => {
  const [active, setActive] = useState(0);
  const [helpList] = useState([
    {
      image: "/help/s1.png",
      title: "Open {link} in your browser and click get passkey button",
      attr: {
        link: "https://www.google.com/account/about/passkeys/",
      },
    },
    {
      image: "/help/s2.png",
      title: "Sign in with your email and password",
    },
    {
      image: "/help/s3.png",
      title: "Click Create Passkey button",
    },
    {
      image: "/help/s4.png",
      title: "Then open this popup and click create a passkey",
    },
  ]);

  if (!open) {
    return null;
  }
  return (
    <div className="fixed left-0 top-0 w-full h-full bg-black/50 flex justify-center items-center z-[999]">
      <div className="bg-white w-[80%] rounded-md flex flex-col relative h-[90%]">
        <div className="justify-between items-center w-full flex border border-l-0 border-r-0 border-t-0 px-6 py-2 mb-3 pr-2">
          <h3 className="text-md font-bold">How to create passkey</h3>
          <div>
            <Button
              variant={"outline"}
              size={"icon"}
              disabled={active === 0}
              onClick={() => {
                setActive((prev) => prev - 1);
              }}
            >
              <ChevronLeft />
            </Button>
            <Button
              variant={"outline"}
              size={"icon"}
              className="ml-3 mr-2"
              disabled={active === helpList.length - 1}
              onClick={() => {
                setActive((prev) => prev + 1);
              }}
            >
              <ChevronRight />
            </Button>
            <Button
              size={"icon"}
              variant={"ghost"}
              onClick={() => setOpen(false)}
            >
              <XIcon />
            </Button>
          </div>
        </div>
        <div className="flex flex-col gap-x-6 gap-y-5 pt-4 px-6 h-[100%]">
          {helpList.map((item, index) => {
            if (active !== index) {
              return null;
            }
            return <PasskeyPopupItem item={item} key={index} index={index} />;
          })}
        </div>
        <div className="mt-3 px-6 py-4 flex gap-5 w-full border border-r-0 border-l-0 border-b-0">
          <Button
            type="submit"
            className="w-[220px]"
            // onClick={() => onSubmit()}
            // disabled={form.formState.isSubmitting}
          >
            Reprocess Document
          </Button>
          <Button
            type="submit"
            onClick={() => setOpen(false)}
            variant={"outline"}
            className="w-[220px]"
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};
